import { useContext} from 'react';
import { DataContext } from '../../DataContext';
import './SubNav.scss';
const url = 'https://www.cnn.com/';

function SubNav({ origin }) {
  const { navData } = useContext(DataContext);

  return (
    <nav className={`subnav subnav-${origin}`}>
      {navData &&
        navData[origin].map((link, i) => {
          return (
            <div className="subnav__section" key={i}>
              {link.url.includes('https') ? (
                <a className="subnav__section__title" href={link.url}>
                  {link.title}
                </a>
              ) : (
                <a className="subnav__section__title" href={`${url}${link.url}`}>
                  {link.title}
                </a>
              )}
              <ul className="subnav__section__list">
                {link.sublinks &&
                  link.sublinks.map((sublink, i) => {
                    return (
                      <li className="subnav__section__listItem" key={i}>
                        {sublink.url.includes('https') ? (
                          <a className="subnav__section__listItem-item" href={sublink.url}>
                            {sublink.title}
                          </a>
                        ) : (
                          <a
                            className="subnav__section__listItem-item"
                            href={`${url}${sublink.url}`}
                          >
                            {sublink.title}
                          </a>
                        )}
                      </li>
                    );
                  })}
              </ul>
            </div>
          );
        })}
    </nav>
  );
}

export default SubNav;
